import React from 'react'
import { userBridge, getUA } from '@penguin/utils'
import styles from './index.module.css'
const ua = getUA()
const linkList = [
  {
    icon: '//static.qiekj.com/static/web/image/no1_1715332211293.png',
    main: '//static.qiekj.com/static/web/image/1_1715332222404.png',
    link: 'https://shop104224478.m.youzan.com/wscgoods/detail/274dy1wrvbdd2x9?scan=1&activity=none&from=kdt&qr=directgoods_3998587074&shopAutoEnter=1',
  },
  {
    icon: '//static.qiekj.com/static/web/image/no2_1715332279996.png',
    main: '//static.qiekj.com/static/web/image/2_1715332290252.png',
    link: 'https://shop104224478.m.youzan.com/wscgoods/detail/1y6x53333eigmw9?scan=1&activity=none&from=kdt&qr=directgoods_2976501350&shopAutoEnter=1',
  },
  {
    icon: '//static.qiekj.com/static/web/image/no3_1715332351130.png',
    main: '//static.qiekj.com/static/web/image/3_1715332365137.png',
    link: 'https://shop104224478.m.youzan.com/wscgoods/detail/2xlr0d1boxsqewa?scan=1&activity=none&from=kdt&qr=directgoods_2976502547&shopAutoEnter=1',
  },
  {
    icon: '//static.qiekj.com/static/web/image/no4_1715332383667.png',
    main: '//static.qiekj.com/static/web/image/4_1715332393251.png',
    link: 'https://shop104224478.m.youzan.com/wscgoods/detail/2xflz9nskhdpios?scan=1&activity=none&from=kdt&qr=directgoods_3998587657&shopAutoEnter=1',
  },
]
const kerunAd = () => {
  const goPage = (item: any) => {
    if (ua === 'app') {
      userBridge('pushWindow', {
        url: item.link,
        closeCurrentWindow: false,
        closeAllWindow: false,
      })
    } else {
      window.location.href = item.link
    }
  }
  return (
    <div className='relative w-screen'>
      <div className={styles['card']}>
        {linkList.map((item: any, idx: number) => {
          return (
            <div key={idx} className={styles['item-list']}>
              <div className={styles['item-top']}>
                <img
                  className={styles['item-main']}
                  onClick={() => goPage(item)}
                  src={item.main}
                  alt=''
                />
                <img className={styles['item-icon']} src={item.icon} alt='' />
              </div>
              <img
                className={styles['item-btn']}
                onClick={() => goPage(item)}
                src='//static.qiekj.com/static/web/image/btn_1715332848490.png'
                alt=''
              />
            </div>
          )
        })}
        <img
          className={styles['item-bottom']}
          src='//static.qiekj.com/static/web/image/bottom_1715410636379.png'
          alt=''
        />
      </div>
      <img
        src='https://static.qiekj.com/static/web/image/kerun-bg.png'
        className={styles['bg-img']}
        alt=''
      />
    </div>
  )
}

export default kerunAd
